import i18n from 'i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import { initReactI18next } from 'react-i18next';

i18n
  .use(
    resourcesToBackend(
      (language: string, namespace: string) =>
        import(`./resources/${language}/${namespace}.json`),
    ),
  )
  .use(initReactI18next)
  .init({
    // 언어 설정
    lng: 'en',
    fallbackLng: 'en',
    supportedLngs: ['en', 'ko'],
    load: 'languageOnly',

    // 네임스페이스
    ns: ['common'],
    defaultNS: 'common',
    fallbackNS: 'common',

    // 보간
    interpolation: {
      escapeValue: false, // React가 XSS 처리
    },

    // React
    react: {
      useSuspense: true,
    },
  });

export default i18n;
